export default "/assets/images/filter-home-wrecker-box.png?55fd8f9643b7632cd73927a4ebbee173";